export const OperatorHelpers = {
    /** Check if input equals to value
     * @param {string|Number } input 
     * @param {string|Number } value 
     * @returns {bool} 
     */
    is: (input, value) => {
        return Object.is(input, value);
    },
    /** Check if input not equals to value
     * @param {string|Number } input 
     * @param {string|Number } value 
     * @returns {bool} 
     */
    isNot: (input, value) => {
        return !Object.is(input, value);
    },
    /** Check if input contains value
    * @param {string } input 
    * @param {string} value 
    * @returns {bool} 
    */
    contains: (input, value) => {
        return input.includes(value)
    },
    /** Check if if input  doesn't contains value
    * @param {string } input 
    * @param {string} value 
    * @returns {bool} 
    */
    doesNotContain: (input, value) => {
        return !input.includes(value)
    },
    /** Check if input greater than value
    * @param {Number } input 
    * @param {Number} value 
    * @returns {bool} 
    */
    isGreaterThan: (input, value) => {
        return input > value;
    },
    /** Check if input less than value
    * @param {Number } input 
    * @param {Number} value 
    * @returns {bool} 
    */
    isLessThan: (input, value) => {
        return input < value;
    },
    /** Check if input array contains value
   * @param {Array } input 
    * @param {string|Number} value 
    * @returns {bool} 
    */
    in: (input, value) => {
        return input.includes(value)
    },
    /** Check if input array not contains  value
    * @param {Array } input 
    * @param {string|Number} value 
    * @returns {bool} 
    */
    notIn: (input, value) => {
        return !input.includes(value)
    },
    /** Check if operands  all elemets are truthy
    * @param {Array } operands  
    * @returns {bool} 
    */
    and: (operands) => {
        return operands.length ? !!operands.reduce((prevVal, currentVal) => prevVal && currentVal) : true
    },
    /** Check if operands  contains at least one truthy element
    * @param {Array } operands 
    * @returns {bool} 
    */
    or: (operands) => {
        return operands.length ? !!operands.reduce((prevVal, currentVal) => prevVal || currentVal) :true
    }
}